type ExtraQuestionRow = readonly [
  id: number,
  scene: string,
  left: string,
  right: string,
  jSide: "left" | "right",
  characters: readonly string[],
];

const EXTRA_QUESTION_ROWS = [
  [71, "小羊在群里问：“下个月搞活动，你来不来？”", "先把日期记上，临近再确认细节", "下个月的我还没加载出来，到时再说", "left", ["大胡老师","小羊"]],
  [72, "群里聊出三套周末方案，剧情已经比连续剧还长。", "三套都先留着，周五看状态选", "投个票定一套吧，再聊天都要黑了", "right", ["大胡老师"]],
  [73, "你最近虽然常在群里潜水，但活动报名今晚截止。", "先在截止前把名报上，安静但有交代", "再观察一下群情，最后一刻决定要不要浮出水面", "left", ["大胡老师"]],
  [74, "周末突然空出两个小时，你更可能：", "不塞安排，空白本身也是一种节目", "从想做清单里捞一件，水灵灵地安排上", "right", ["大胡老师"]],
  [75, "到了 KTV 才发现预订的包厢临时没了。", "马上联系备选店，重新发集合位置", "先在附近逛逛，现场长出一个新副本", "left", ["大胡老师"]],
  [76, "群里只说“晚点碰头”，没说这个“晚点”到底几点。", "晚点是一种氛围，到时群里问", "追问一个具体时间和定位，拒绝时空谜语", "right", ["大胡老师"]],
  [77, "买票时有三班车都差不多，你会：", "按时间和价格选一班，直接下单", "三个页面都开着，再等等哪班最有眼缘", "left", ["大胡老师"]],
  [78, "手里同时有 PPT、简历和活动报名三件事。", "哪个突然有感觉就先碰哪个", "排个先后，一件件清掉，脑子少开几个窗口", "right", ["大胡老师"]],
  [79, "周六下午突然有人喊：“现在去看落日吗？”", "先看看晚上的安排和返程会不会冲突", "落日不等人，鞋一穿就出门", "left", ["大胡老师"]],
  [80, "活动结束后，照片、账单和表情包一起刷屏。", "先快乐存图，AA 以后总会有人想起来", "趁人齐把照片、账单和遗漏一次收完", "right", ["大胡老师"]],
  [81, "轮到你准备接下来一周的每日宜忌，你会更像：", "每天醒来再接收宇宙信号，主打新鲜", "提前攒几个模板，当天再按心情微调", "right", ["二胡老师"]],
  [82, "今日幸运随身物候选有奶茶、充电宝和一把梳子。", "拍板一个，今天的幸运只能有一位正宫", "三个都先留着，写到哪一个算哪一个", "left", ["二胡老师"]],
  [83, "你还没发今日幸运词，群友早上已经开始敲碗。", "等灵感自然出现，被催到再极限输出", "前一晚先写好，早上定时水灵灵地出现", "right", ["二胡老师"]],
  [84, "你做的每日群历还要顺手带一句当天的活动提醒。", "固定时间发，提醒也提前放进文案", "想起来再补一句，群消息讲究自然生长", "left", ["二胡老师"]],
  [85, "你原定的幸运词是“冲鸭”，但当天一早大家都在吐槽加班。", "保留“冲鸭”，这种反差感正好成为今日抽象", "临时换成更贴当天气氛的词，再发出去", "right", ["二胡老师"]],
  [86, "你收到一句投稿：“今日宜快乐”，其他信息什么都没写。", "先问清楚具体宜什么、忌什么，再排版", "先收下这份朴素快乐，剩下的边写边长", "left", ["二胡老师"]],
  [87, "你一口气收到群友贡献的十个幸运词，每个都挺好笑。", "全部存着，以后每天随机翻牌", "按当天主题筛到一个，其他的归进候选库", "right", ["二胡老师"]],
  [88, "早上同时撞上发群历、吃早餐和赶地铁。", "按顺序把文案发完，再处理下一件事", "三个线程来回切，哪个先响就先救哪个", "left", ["二胡老师"]],
  [89, "半夜突然想到一个“超绝幸运词”。", "现在就丢群里，凌晨的灵感也配拥有姓名", "先记进明早模板，到该出现的时间再出现", "right", ["二胡老师"]],
  [90, "月底翻自己发过的群历，发现有几个幸运词重复了。", "做个已用词清单，下个月尽量不重样", "重复说明缘分未尽，明天照样可以再来", "left", ["二胡老师"]],
  [91, "群里说下个月再搞一次乱讲 PPT 大赛。", "先记下报名和准备时间，主题可以慢慢想", "等一个命中注定的主题砸中我，再决定报不报", "left", ["小叶老师"]],
  [92, "晚饭候选有五家店，大家每家都说“也可以”。", "再刷一会儿小红书，说不定还有第六家", "从这五家里定一家，选择困难到此为止", "right", ["小叶老师"]],
  [93, "简历明早就要投，但今晚又发现三处能优化。", "先按重要程度改完，留出最后检查时间", "等状态最好的那一刻再集中爆改，DDL 会赐予力量", "left", ["小叶老师"]],
  [94, "面前是一整个没有安排的周六。", "睡到自然醒，看醒来后的自己想去哪", "前一晚先放两三个时间节点，其他时间再自由发挥", "right", ["小叶老师"]],
  [95, "Citywalk 走到一半，杭州突然下大雨。", "立刻切到准备好的室内路线", "沿着屋檐继续走，看看雨会把大家带到哪里", "left", ["小叶老师"]],
  [96, "活动通知只写了四个字：“有空就来”。", "先看当天群里怎么发展，命运自会通知我", "问清时间、地点和要带什么，再决定", "right", ["小叶老师"]],
  [97, "给盲盒饮料活动选饮料，货架上十几款都没喝过。", "按预算和口味范围挑一瓶，选完收手", "先逛完整个便利店，最后让直觉负责", "left", ["小叶老师"]],
  [98, "浏览器已经开了十几个标签页，每个都“等会儿要看”。", "在标签页之间来回横跳，灵感到了自然会关", "先关掉不相关的，一个个看完再开新的", "right", ["小叶老师"]],
  [99, "临下班突然收到一句：“今晚 KTV，来吗？”", "先看明早安排和返程时间，再回能不能来", "先回“包的”，剩下的问题交给晚上的我", "left", ["小叶老师"]],
  [100, "旅行回来，手机里多了三百张差不多的照片。", "都留着，以后想看时自然会遇见真爱", "当晚筛掉重复的，分好相册再睡", "right", ["小叶老师"]],
  [101, "你准备从北京来杭州参加群活动。", "人先到杭州，再根据天气现场解锁地图", "提前对好车票、住宿、活动时间和备选方案", "right", ["赵老师"]],
  [102, "群里把活动流程讨论出了第五版。", "设个截止时间，确认最终版后不再新增支线", "大家继续补充，好点子不应该被版本号限制", "left", ["赵老师"]],
  [103, "乱讲 PPT 距离 DDL 还有一周。", "先等压力值攒满，DDL 战神讲究后程发力", "倒排一下进度，每天收掉一部分", "right", ["赵老师"]],
  [104, "签到、分享、游戏和合照四个环节都由你来安排。", "先排好顺序和大概时长，流程老师上线", "只记住要做这四件事，现场看气氛切换", "left", ["赵老师"]],
  [105, "第一个环节太好玩，比预计多用了半小时。", "大家正上头就继续，后面环节到时再说", "马上调整后面的时长，把主流程重新排好", "right", ["赵老师"]],
  [106, "有人说：“流程随便搞搞就行。”", "先明确目标、分工和最后要产出什么", "“随便”就是最大的创作空间，开了再说", "left", ["赵老师"]],
  [107, "活动有两套都能用的方案。", "两套都带着，现场看哪套更有节目效果", "定一套主方案，另一套只作为备用", "right", ["赵老师"]],
  [108, "群里同时在聊场地、吃饭和游戏规则。", "一个话题先聊出结论，再 cue 下一个", "三个话题并行推进，群聊就该长出很多支线", "left", ["赵老师"]],
  [109, "晚上十点突然有人约夜宵。", "先去再说，到了自然知道几点撤", "先看明早安排，顺手约好结束时间", "right", ["赵老师"]],
  [110, "活动刚结束，大家看向你，等你 cue 复盘。", "趁热发结论、问题和下次行动项", "先快乐散场，群活动又不是周报答辩", "left", ["赵老师"]],
  [111, "鹅崽从新疆放假回杭州，群里准备接风。", "先对好返杭日期和见面时间，再安排接风局", "落地以后群里一喊，杭州本地副本随时开", "left", ["鹅崽"]],
  [112, "卷在群里问：“鹅崽接风局第一顿吃什么？”", "先列一串杭州味道，饿到那天再翻牌", "现在定一家，回来的第一顿必须有名有姓", "right", ["鹅崽","卷"]],
  [113, "课程作业和回杭州收行李撞在同一周。", "提前拆到每天，给赶路留出完整时间", "先处理当下最有感觉的，最后几天自然会爆发战斗力", "left", ["鹅崽"]],
  [114, "假设你是杭州本地人，要带外地朋友玩一天。", "先串好路线、吃饭和休息点，少走回头路", "从一个熟悉的地方出发，边走边决定下一站", "right", ["鹅崽"]],
  [115, "到西湖边才发现人山人海。", "立刻启用本地人的备用路线，换个入口", "拐进没走过的小路，说不定随机到隐藏地图", "left", ["鹅崽"]],
  [116, "老师只说“这个版本尽快交”，没给日期。", "先做起来，等对方催的时候自然知道多快", "追问明确截止时间和要求，拒绝猜谜", "right", ["鹅崽"]],
  [117, "新疆回杭州的车次和航班各有优缺点。", "按价格、时间和换乘次数选一个，早点落票", "几个选项都留着，等等价格和心情一起做决定", "left", ["鹅崽"]],
  [118, "作业、打包和群消息同时堆过来。", "哪个最吵先处理哪个，多线程也是一种能力", "列个顺序，一件做完再切下一件", "right", ["鹅崽"]],
  [119, "卷在上海突然说：“明天要不要来找我？”", "先查交通和后天安排，确认来回时间再答应", "先买最近一班票，合住过的人主打一个说见就见", "left", ["鹅崽","卷"]],
  [120, "长途回来，行李箱、照片和报销票据堆在一起。", "先躺平回血，这些东西又不会长腿跑掉", "当天把衣服、票据和照片各自归位", "right", ["鹅崽"]],
  [121, "你开始想下一次旅行。", "先去车站或机场，哪张票顺眼就去哪", "提前定目的地、交通和住宿，再留空白时间乱逛", "right", ["小羊"]],
  [122, "你和小羊一起组织活动，群友一下贡献了十二个脑洞。", "先筛出三四个，投票到点就定", "继续让脑洞飞一会儿，说不定第十三个封神", "left", ["小羊"]],
  [123, "乱讲 PPT 只剩三天，你更像：", "前两天继续吸收宇宙灵感，最后一晚直接封神", "把大纲、素材和排练拆开，每天收掉一块", "right", ["小羊"]],
  [124, "你准备和小羊一起做一桌饭给大家吃。", "先定菜单、买菜量和开饭时间，再进厨房", "打开冰箱看今天谁有缘，边做边决定下一道", "left", ["小羊"]],
  [125, "精心安排的户外活动遇上杭州暴雨。", "宣布今天是随机副本，大家附近随缘找地方", "马上切室内备选，把新定位和时间发清楚", "right", ["小羊"]],
  [126, "旅行计划里有人写了一句：“当天随便走走。”", "先定集合、返程和几个边界，中间再随便走", "真正的随便不需要边界，醒来再看地图", "left", ["小羊"]],
  [127, "两个旅行目的地都很想去。", "两个攻略都存着，出发前早上看心情翻牌", "按预算、天气和假期长度选一个，另一个留给下次", "right", ["小羊"]],
  [128, "活动群、厨房和旅行行李同时开工。", "按紧急程度一件件关掉任务，避免十二线程", "哪里需要就切去哪里，主打一个流动型项目管理", "left", ["小羊"]],
  [129, "晚上刷到一张明早出发的特价票。", "先下单，行李和请假都是买完票以后才会的技能", "先核对假期、证件和返程，再决定这波羊毛薅不薅", "right", ["小羊"]],
  [130, "群友吃完你和小羊做的饭，桌上进入大型残局。", "先收剩菜、算 AA、清厨房，再坐下聊天", "先享受夸夸和饭后聊天，碗晚点洗也不会影响美味", "left", ["小羊"]],
  [131, "你准备和壮老师、卷下周去游泳。", "先定泳馆、时间和各自怎么过去", "下周谁先想起来谁喊，游泳讲究一个水到渠成", "left", ["壮老师","卷"]],
  [132, "同一天有游泳、KTV 和盲盒饮料三个活动。", "哪个群消息最热闹就刷新到哪个活动", "先选一个主活动，其他的明确说这次不去", "right", ["壮老师"]],
  [133, "活动报名今晚截止，你还没有回复。", "在截止前确认来不来，随机但不失联", "最后几分钟再看状态，压轴刷新才有节目效果", "left", ["壮老师"]],
  [134, "周六一整天暂时没安排。", "先让它空着，随时接收群里的随机召唤", "至少留一个确定项目，其他时间再机动", "right", ["壮老师"]],
  [135, "你跟壮老师、卷到了泳馆，发现临时闭馆。", "查附近备用泳馆或换成另一项运动", "泳游不成就去吃饭，今天的剧情现场改写", "left", ["壮老师","卷"]],
  [136, "卷对你说：“下午晚点去游泳吧。”", "泳衣先塞包里，等卷的下一条消息", "问清几点、哪个馆和最晚几点结束", "right", ["壮老师","卷"]],
  [137, "游完泳后，大家又提出吃饭、桌游和散步。", "先定一个主选项，别让湿头发陪大家开会", "三个都留着，出泳馆后看谁的声音最大", "left", ["壮老师"]],
  [138, "出门前要装泳包、回消息、查路线。", "一边找泳镜一边回群，看到什么先做什么", "按清单装完包，再回消息和出发", "right", ["壮老师"]],
  [139, "活动已经开始一小时，群里突然问你来不来。", "先确认几点结束、过去要多久，再决定是否刷新", "直接出门，随机出现的人不需要铺垫", "left", ["壮老师"]],
  [140, "你随机参加完活动，准备撤。", "挥挥手丝滑离场，AA 和照片以后群里见", "先确认账单、随身物和照片，再正式下线", "right", ["壮老师"]],
  [141, "棒老师把英国认识的朋友介绍给你，你准备带对方在杭州玩一天。", "落地先喝杯东西，再随机探索杭州", "提前查开放时间、预约和交通，排出一条路线", "right", ["棒老师"]],
  [142, "你替棒老师去二毛卤味摊当一天摊主，能卖的东西很多。", "开摊前定好主推、价格和摆放顺序", "都摆出来，今天顾客爱买什么就主推什么", "left", ["棒老师"]],
  [143, "卖酒时离最后下单时间只剩五分钟。", "先问一圈还有谁想加，五分钟也能再开一局", "按已经统计好的数量下单，不临时扩单", "right", ["棒老师"]],
  [144, "一天里同时要看摊、送酒和参加聚会。", "先排路线和时间，尽量不来回折返", "哪边先来消息就先去哪边，现实版开放世界", "left", ["棒老师"]],
  [145, "卤味摊刚摆好，突然开始下雨。", "先根据现场情况移动摊位，边搬边决定怎么摆", "按预想的防雨方案收货、遮挡、再继续营业", "right", ["棒老师"]],
  [146, "有人让你推荐酒，只说“随便，好喝就行”。", "先问预算、口味和场合，再给具体选择", "拿一瓶自己觉得有意思的，惊喜也是推荐的一部分", "left", ["棒老师"]],
  [147, "聚会有三瓶风格完全不同的酒。", "都开一点，人生在于横向测评", "按人数和菜先选一瓶，喝完再决定要不要开下一瓶", "right", ["棒老师"]],
  [148, "卤味摊同时有人点单、付款、问口味和催补货。", "先把点单、收款和出货排成固定顺序", "哪边卡住就先救哪边，摊主需要八只手", "left", ["棒老师"]],
  [149, "棒老师在英国认识的朋友突然在群里说：“明天飞杭州，落地见？”", "先答应接机，见到人再商量去哪", "确认落地时间、交通和当天安排后再定", "right", ["棒老师"]],
  [150, "一天摊主体验结束，桌上还剩货、账和包装袋。", "先盘货、对账、收摊，再庆祝今天营业成功", "先拍照发群庆祝，残局等快乐完了再处理", "left", ["棒老师"]],
  [151, "这次你和红领巾一起开车带大家出去玩。", "提前查路线、停车、天气和大概油费", "人坐齐就开，导航会替大家思考人生", "left", ["红老师"]],
  [152, "红老师帮你算出双十一有三套买法都很省。", "三个方案都留到零点，临场看平台会不会变规则", "选总价和风险最合适的一套，提前锁定买法", "right", ["红老师"]],
  [153, "优惠券还有半小时过期，购物车没结算。", "核对清单和优惠，留几分钟完成支付", "最后三分钟才最有双十一的灵魂，手速就是生产力", "left", ["红老师"]],
  [154, "自驾出游当天，大家起床速度非常随缘。", "谁醒了谁下楼，凑齐再研究几点出发", "提前定集合、出发和休息点，到点按计划走", "right", ["红老师"]],
  [155, "开车途中突然遇到大堵车。", "马上切路线并重新估算到达时间", "歌单一开，堵车也可以临时变成车内 KTV", "left", ["红老师"]],
  [156, "这次你开车，群友说：“带我们在附近转转吧。”", "先上车，开到哪儿觉得顺眼就停", "先问人数、目的地和返程时间，再定路线", "right", ["红老师"]],
  [157, "为了凑优惠，购物车里出现了几件“好像也用得上”的东西。", "只保留确实需要、能进最优方案的商品", "先都留着，满减世界里万物都有存在的理由", "left", ["红老师"]],
  [158, "出发前要检查车况、加油、发定位和接人。", "几件事穿插着做，哪件顺路先做哪件", "按清单逐项确认，完成一项划一项", "right", ["红老师"]],
  [159, "晚上十点，有人突然提议明早自驾看日出。", "先确认睡眠、天气和谁能准时起床", "日出都发邀请函了，先答应再设闹钟", "left", ["红老师"]],
  [160, "自驾回来，油费、过路费和停车费散在好几个人手机里。", "大家有空再慢慢丢群里，账不会过期", "趁记得清楚汇总完，一次把 AA 发掉", "right", ["红老师"]],
  [161, "你刚搬到上海，准备探索第一个完整周末。", "坐一站没去过的地铁，出站再决定怎么玩", "提前挑区域、展览和吃饭地点，串成一条路线", "right", ["卷"]],
  [162, "一张画试出了两套都很好看的配色。", "先做小样比较，选一套继续画完", "两套都舍不得，边画边看它最后自己长成什么色", "left", ["卷"]],
  [163, "毕业作品离 DDL 还有一周。", "先让灵感继续发酵，最后几天进入超频模式", "拆成每天的完成量，按节点推进到交稿", "right", ["卷"]],
  [164, "你准备和卷、小羊一起做饭给大家吃。", "先定菜单、分工和出菜顺序", "先去菜场看什么新鲜，买回来再现场创作", "left", ["卷","小羊"]],
  [165, "你跟卷、壮老师到了泳馆，发现今天只开放一条泳道。", "那就换个附近活动，今天主打随机", "查预约和附近泳馆，尽量把游泳计划保住", "right", ["卷","壮老师"]],
  [166, "你和鹅崽合住时，对方说：“今晚随便吃点。”", "先问想吃饭还是面、有没有忌口，再开火", "打开冰箱自由发挥，做出来什么就吃什么", "left", ["卷","鹅崽"]],
  [167, "周末既想留在上海画画，又想回杭州见大家。", "两个选项都留到周五，哪个念头赢了就去哪", "比较时间和成本，提前选一个并安排好", "right", ["卷"]],
  [168, "搬家、画画和做饭三件事同时堆着。", "列个顺序，先把最影响后续的事情做完", "哪件卡住就换下一件，三条线轮流推进", "left", ["卷"]],
  [169, "你突然想从上海回杭州玩一天。", "先买票再群里喊，随机的人生需要一点行动力", "先问大家是否有空、确认来回时间再买票", "right", ["卷"]],
  [170, "一张画终于完成，旁边还堆着素材和搬家纸箱。", "先归档文件、收好画具，再开启下一件事", "先发群让大家起名，收拾可以等下一阵灵感低潮", "left", ["卷"]],
  [171, "下个月有群活动，你虽然一直潜水但其实有点想去。", "先默默记进日历，临近再确认一次", "等群里再次聊到时看状态，潜水员自有出现时机", "left", ["阿jo"]],
  [172, "你觉得两个活动方案都“超级棒”。", "两个都夸住，先别让任何一个方案受伤", "夸完还是投一票，帮群里把方案定下来", "right", ["阿jo"]],
  [173, "活动报名表今晚截止，你还没说话。", "安静地在截止前填完，不冒泡也能推进剧情", "等最后一次提醒出现，再决定是否突然刷新", "left", ["阿jo"]],
  [174, "周六空出半天，群里暂时没有活动消息。", "继续保持空白，随时欢迎意外剧情", "给自己定一个想做的项目，其他时间再随机", "right", ["阿jo"]],
  [175, "大家到了餐厅，发现今天临时歇业。", "马上找备选店、发定位，把队伍重新拉起来", "沿街看看哪家有缘，顺便夸夸每个新选项", "left", ["阿jo"]],
  [176, "群里 @ 你：“有空来给大家夸夸！”但没说几点。", "看到下一次消息时自然出现，夸夸没有时刻表", "先问清活动时间和环节，预留好出现窗口", "right", ["阿jo"]],
  [177, "改简历时看到三个版本，各有值得夸的地方。", "按目标岗位选一版继续改，今天收口", "三个都保留，说不定未来的岗位各有缘分", "left", ["阿jo"]],
  [178, "未读群消息、工作和待回私聊同时出现。", "几个窗口来回点，哪条顺眼先回哪条", "按紧急程度清完一类，再处理下一类", "right", ["阿jo"]],
  [179, "你突然被 @：“我们已经到 KTV 了，来不来？”", "先确认结束时间和过去多久，再决定", "直接出现并开启夸夸模式，神兵天降不需要预告", "left", ["阿jo"]],
  [180, "活动结束，你准备再次潜水。", "发一句“大家都太棒了”然后丝滑下潜", "夸完顺手确认照片、AA 和下次要做的事", "right", ["阿jo"]],
  [181, "有人提前一个月私聊你：“这场活动来吗？”", "等临近了再看，那时的状态才是真实状态", "先确认日期并记进日历，细节之后再补", "right", ["牙刷老师"]],
  [182, "私聊里有人给你两个活动方案，问你选哪个。", "挑一个明确回复，帮助群里结束选择题", "两个都可以，先把可能性留着", "left", ["牙刷老师"]],
  [183, "活动今晚截止报名，你还在神秘状态。", "等私聊再来一次提醒，最后时刻决定", "在截止前主动确认，哪怕群里不冒泡", "right", ["牙刷老师"]],
  [184, "已经答应周六参加活动。", "提前留出时间，避免又安排上别的事情", "先记个大概，周六当天再重新拼时间", "left", ["牙刷老师"]],
  [185, "出门前十分钟，群里临时换了集合地点。", "跟着新定位走，路上再看怎么到", "重新查路线和到达时间，再回复是否会迟到", "right", ["牙刷老师"]],
  [186, "私聊只说：“这周有活动，到时叫你。”", "先问日期、地点和大概时长", "回复“好，叫我就行”，信息以后自然会补全", "left", ["牙刷老师"]],
  [187, "对方给了三个都能参加的时间。", "三个都先说可以，给组织者最大操作空间", "选一个最合适的时间，直接确认下来", "right", ["牙刷老师"]],
  [188, "准备出门时还要充电、收东西和查路线。", "按清单做完一项再做下一项", "看到什么先拿什么，出门前总能神奇地凑齐", "left", ["牙刷老师"]],
  [189, "你突然收到私聊：“我们就在你楼下，来吗？”", "直接下楼，神秘嘉宾就该零帧起手", "先问去哪、多久、后面还有什么安排再决定", "right", ["牙刷老师"]],
  [190, "活动结束，你准备安静退场。", "离开前先结清 AA、确认物品和返程", "趁大家没注意丝滑消失，后续群里再补", "left", ["牙刷老师"]],
] as const satisfies readonly ExtraQuestionRow[];

export const EXTRA_QUESTIONS = EXTRA_QUESTION_ROWS.map(
  ([id, scene, left, right, jSide, characters]) => ({
    id,
    scene,
    left,
    right,
    jSide,
    characters,
  }),
);
